import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

type TeamMemberSummaryProps = {
  totalCount: number;
};

export class TeamMemberSummary extends Record<TeamMemberSummaryProps>({
  totalCount: 0,
}) {}

export const createTeamMemberSummary = (props?: CreateFunctionInput<TeamMemberSummary>) =>
  props instanceof TeamMemberSummary ? props : new TeamMemberSummary(fromJS(props));
